import type { TransferEndpointLocationRow } from "@/lib/transferEndpointLocations";

import type { StockingOrderProgress } from "./stockingOrdersApi";

export function stockingOrderProgressLabel(progress: StockingOrderProgress): string {
  switch (progress) {
    case "needs_batch":
      return "Needs batch";
    case "needs_shipment":
      return "Needs shipment";
    case "needs_transfer_plan":
      return "Needs transfer plan";
    case "transfer_planned":
      return "Transfer planned";
    case "transfer_allocated":
      return "Transfer allocated";
    case "complete":
      return "Complete";
    case "cancelled":
      return "Cancelled";
    default:
      return progress;
  }
}

export function defaultStockingTransferDestinationId(
  originLocationId: number,
  locations: readonly TransferEndpointLocationRow[],
): number | null {
  const origin = locations.find((location) => location.id === originLocationId);
  const originCode = origin?.mrp_site_code?.trim().toLowerCase() ?? "";
  const originAbbreviation = origin?.abbreviation?.trim().toUpperCase() ?? "";
  const isSuntronic = originCode === "suntronic" || originAbbreviation === "SUN";
  if (!isSuntronic) {
    return null;
  }
  const sgs = locations.find((location) => {
    const siteCode = location.mrp_site_code?.trim().toLowerCase() ?? "";
    const abbreviation = location.abbreviation?.trim().toUpperCase() ?? "";
    return siteCode === "sgs" || abbreviation === "SGS";
  });
  return sgs?.id ?? null;
}

export function buildStockingBatchRequestKey(buildOrderId: number, quantity: number, destinationLocationId: number): string {
  return `stocking-batch:${String(buildOrderId)}:${String(quantity)}:${String(destinationLocationId)}`;
}

export function buildStockingBatchCreateBody(input: {
  quantity: number;
  destinationLocationId: number;
  requestKey: string;
  mfrShipByDate?: string | null;
}): {
  quantity: number;
  destination_location_id: number;
  request_key: string;
  mfr_ship_by_date: string | null;
} {
  return {
    quantity: input.quantity,
    destination_location_id: input.destinationLocationId,
    request_key: input.requestKey,
    mfr_ship_by_date: input.mfrShipByDate ?? null,
  };
}
